// extracted by mini-css-extract-plugin
export default {"contentWrapper":"WeightHistoryPage_contentWrapper__ne3vR","content":"WeightHistoryPage_content__iQd19"};